import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'om-input-formly',
  templateUrl: './om-input-formly.component.html',
  styleUrls: ['./om-input-formly.component.scss'],
})
export class OmInputFormlyComponent extends FieldType implements OnInit {

  ngOnInit(): void {
    if (this.props.required) {
      this.formControl.addValidators(Validators.required);
    }
    
    if (this.field['omType'] === 'CONFIGURABLE_ISSUE_FIELD') {
      this.formControl.disable({emitEvent: false});
    }
  }

}
